import { render } from "./NoAuthorization.vue?vue&type=template&id=a094ae56"
import script from "./NoAuthorization.vue?vue&type=script&lang=js"
export * from "./NoAuthorization.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__